import React, { useEffect, useState } from 'react';
import { APIURL } from '../../configApi/apiConfig';
import axios from '../../configApi/axiosConfig';
import { Pencil, Trash2, Save, Eraser, Phone, Search, RefreshCw, Eye, EyeOff, UserPlus } from 'lucide-react';

const nuevoFormulario = {
  Extension: '',
  Password_SIP: '',
  Activo: true
};

export function ExtensionesTelefonicasComponent() {
  const [registros, setRegistros] = useState([]);
  const [registrosFiltrados, setRegistrosFiltrados] = useState([]);
  
  // Filtros
  const [filtroExtension, setFiltroExtension] = useState('');
  const [filtroEstado, setFiltroEstado] = useState('Todos'); // 'Todos', 'Activo', 'Inactivo'

  const [formData, setFormData] = useState(nuevoFormulario);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [toast, setToast] = useState({ show: false, type: 'success', message: '' });

  // Asignar Usuario
  const [asignarModalOpen, setAsignarModalOpen] = useState(false);
  const [extensionParaAsignar, setExtensionParaAsignar] = useState(null);
  const [usuarioAsignado, setUsuarioAsignado] = useState('');
  const [usuarioSeleccionadoId, setUsuarioSeleccionadoId] = useState(null);
  const [grupoAsignado, setGrupoAsignado] = useState('');
  const [guardandoAsignacion, setGuardandoAsignacion] = useState(false);
  const [filtroUsuario, setFiltroUsuario] = useState('');
  const [usuariosList, setUsuariosList] = useState([]);
  const [gruposList, setGruposList] = useState([]);
  const [cargandoUsuarios, setCargandoUsuarios] = useState(false);

  useEffect(() => {
    fetchExtensiones();
  }, []);

  useEffect(() => {
    const fetchGrupos = async () => {
      try {
        const response = await axios.get(APIURL.getRolesWeb());
        setGruposList(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error('Error al cargar grupos:', error);
      }
    };
    fetchGrupos();
  }, []);

  useEffect(() => {
    if (grupoAsignado) {
      fetchUsuariosPorGrupo(grupoAsignado);
    } else {
      setUsuariosList([]);
    }
  }, [grupoAsignado]);

  useEffect(() => {
    aplicarFiltros();
  }, [registros, filtroExtension, filtroEstado]);

  useEffect(() => {
    if (!toast.show) return;
    const timer = setTimeout(() => setToast({ ...toast, show: false }), 3500);
    return () => clearTimeout(timer);
  }, [toast.show]);

  const mostrarToast = (type, message) => setToast({ show: true, type, message });

  const fetchExtensiones = async () => {
    try {
      setLoading(true);
      const response = await axios.get(APIURL.getExtensionesSIP());
      const data = Array.isArray(response.data) ? response.data : (response.data.data || []);
      
      let asignaciones = [];
      try {
        const asigResponse = await axios.get(APIURL.getUsuarioExtension());
        asignaciones = Array.isArray(asigResponse.data) ? asigResponse.data : (asigResponse.data.data || []);
      } catch (err) {
        console.error('Error al cargar asignaciones:', err);
      }

      const mapeos = await Promise.all(data.map(async ext => {
        const idExt = ext.idExtension_sip || ext.IdExtension;
        const asig = asignaciones.find(a => a.idExtension_sip === idExt);
        let nombreAsignado = null;
        if (asig) {
          try {
            const userResp = await axios.get(APIURL.get_UsuariobyId(asig.idUsuario));
            if (userResp.data) {
              const u = userResp.data;
              nombreAsignado = u.Nombre || u.Usuario || u.Nombres || `Usuario ${asig.idUsuario}`;
            } else {
              nombreAsignado = `Usuario ${asig.idUsuario}`;
            }
          } catch(e) {
             nombreAsignado = `Usuario ${asig.idUsuario}`;
          }
        }

        return {
          IdExtension: idExt,
          Extension: ext.extension || ext.Extension,
          Password_SIP: ext.password_sip || ext.Password_SIP,
          Activo: ext.activo !== undefined ? ext.activo : ext.Activo,
          UsuarioAsignado: nombreAsignado,
          IdAsignacion: asig ? asig.idUsuario_extension : null
        };
      }));

      setRegistros(mapeos);
    } catch (error) {
      console.error('Error al cargar extensiones:', error);
      setRegistros([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchUsuariosPorGrupo = async (idGrupo) => {
    try {
      setCargandoUsuarios(true);
      setUsuariosList([]);
      const response = await axios.get(APIURL.getUsuarioPorROL(idGrupo));
      const data = Array.isArray(response.data) ? response.data : (response.data.data || []);
      setUsuariosList(data);
    } catch (error) {
      console.error('Error al cargar usuarios por grupo:', error);
      setUsuariosList([]);
    } finally {
      setCargandoUsuarios(false);
    }
  };

  const aplicarFiltros = () => {
    let filtrados = [...registros];

    if (filtroExtension.trim() !== '') {
      filtrados = filtrados.filter(item => 
        String(item.Extension).toLowerCase().includes(filtroExtension.toLowerCase())
      );
    }

    if (filtroEstado !== 'Todos') {
      const activo = filtroEstado === 'Activo';
      filtrados = filtrados.filter(item => Boolean(item.Activo) === activo);
    }

    setRegistrosFiltrados(filtrados);
  };

  const manejarCambio = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const limpiarFormulario = () => {
    setFormData(nuevoFormulario);
    setEditingId(null);
    setError('');
  };

  const validarFormulario = () => {
    if (!formData.Extension.trim() || !formData.Password_SIP.trim()) {
      setError('La extensión y el Password SIP son obligatorios.');
      return false;
    }
    
    // Validar duplicados al crear
    if (!editingId) {
      const existe = registros.some(r => String(r.Extension) === String(formData.Extension));
      if (existe) {
        setError('Ya existe una extensión con ese número.');
        return false;
      }
    }
    return true;
  };

  const guardarRegistro = async (e) => {
    e.preventDefault();
    setError('');

    if (!validarFormulario()) return;

    // Regla: Servidor SIP quemado, no se muestra pero se envía en la creación si el backend lo requiere.
    // Aunque el requerimiento dice "Se asignará automáticamente al guardar", se enviará por precaución.
    const payload = {
      extension: formData.Extension,
      password_sip: formData.Password_SIP,
      activo: Boolean(formData.Activo),
      servidor_sip: "192.168.1.100" // Valor fijo asignado desde la aplicación
    };

    try {
      setSaving(true);
      if (editingId) {
        await axios.patch(APIURL.patchExtensionSIP(editingId), {
          extension: formData.Extension,
          password_sip: formData.Password_SIP,
          activo: Boolean(formData.Activo)
        });
        mostrarToast('success', 'Extensión actualizada correctamente.');
      } else {
        await axios.post(APIURL.postExtensionSIP(), payload);
        mostrarToast('success', 'Extensión creada correctamente.');
      }
      limpiarFormulario();
      await fetchExtensiones();
    } catch (saveError) {
      console.error('Error al guardar:', saveError);
      setError(saveError.response?.data?.message || 'Error al guardar la extensión.');
      mostrarToast('error', 'No se pudo guardar la extensión.');
    } finally {
      setSaving(false);
    }
  };

  const cargarParaEditar = (item) => {
    setEditingId(item.IdExtension);
    setFormData({
      Extension: item.Extension,
      Password_SIP: item.Password_SIP || '',
      Activo: Boolean(item.Activo)
    });
    setError('');
  };

  const confirmarEliminacion = async () => {
    if (!confirmDeleteId) return;
    try {
      const ext = registros.find(r => r.IdExtension === confirmDeleteId);
      if (ext) {
        // Enviar PATCH para inactivar
        await axios.patch(APIURL.patchExtensionSIP(confirmDeleteId), {
          extension: ext.Extension,
          password_sip: ext.Password_SIP,
          activo: false
        });
        mostrarToast('success', 'Extensión marcada como inactiva correctamente.');
        await fetchExtensiones();
      }
    } catch (error) {
      console.error('Error al inactivar la extensión:', error);
      mostrarToast('error', 'Error al inactivar la extensión.');
    } finally {
      setConfirmDeleteId(null);
    }
  };

  const abrirModalAsignacion = (item) => {
    setExtensionParaAsignar(item);
    setUsuarioAsignado(''); // Resetear el usuario seleccionado
    setUsuarioSeleccionadoId(null);
    setGrupoAsignado(''); // Resetear el grupo
    setFiltroUsuario(''); // Resetear filtro de búsqueda
    setAsignarModalOpen(true);
  };

  const guardarAsignacion = async () => {
    if (!usuarioSeleccionadoId) {
      mostrarToast('error', 'Debes seleccionar un usuario.');
      return;
    }
    try {
      setGuardandoAsignacion(true);
      
      const payloadAsignacion = {
        idUsuario: parseInt(usuarioSeleccionadoId, 10),
        idExtension_sip: extensionParaAsignar.IdExtension,
        activo: true
      };

      if (extensionParaAsignar.IdAsignacion) {
        await axios.patch(APIURL.patchUsuarioExtension(extensionParaAsignar.IdAsignacion), payloadAsignacion);
      } else {
        await axios.post(APIURL.postUsuarioExtension(), payloadAsignacion);
      }

      mostrarToast('success', `Usuario asignado a la extensión ${extensionParaAsignar.Extension} correctamente.`);
      setAsignarModalOpen(false);
      await fetchExtensiones();
    } catch (error) {
      console.error('Error al asignar usuario:', error);
      mostrarToast('error', 'Error al asignar usuario a la extensión.');
    } finally {
      setGuardandoAsignacion(false);
    }
  };

  const registroAEliminar = registros.find(r => r.IdExtension === confirmDeleteId);

  return (
    <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto space-y-5">
        
        {toast.show && (
          <div className={`fixed top-5 right-5 z-50 px-4 py-3 rounded-xl shadow-lg text-sm text-white ${toast.type === 'success' ? 'bg-green-600' : 'bg-red-600'}`}>
            {toast.message}
          </div>
        )}

        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 flex items-center gap-4">
          <div className="bg-primaryBlue/10 p-3 rounded-full text-primaryBlue">
            <Phone size={32} />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-gray-800 tracking-tight">Extensiones Telefónicas SIP</h2>
            <p className="text-sm text-gray-500 mt-1 font-medium">Administración y control de extensiones SIP para llamadas.</p>
          </div>
        </div>

        {/* Formulario */}
        <form onSubmit={guardarRegistro} className="bg-white rounded-2xl shadow-sm border border-gray-200 p-5">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">{editingId ? 'Editar Extensión' : 'Nueva Extensión'}</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Extensión *</label>
              <input
                type="text"
                name="Extension"
                value={formData.Extension}
                onChange={manejarCambio}
                disabled={!!editingId} // Solo editable al crear
                className="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primaryBlue disabled:bg-gray-100"
                placeholder="Ej. 1001"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Password SIP *</label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="Password_SIP"
                  value={formData.Password_SIP}
                  onChange={manejarCambio}
                  className="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primaryBlue pr-10"
                  placeholder="******"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600 transition-colors"
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <div className="flex items-center mt-6">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  name="Activo"
                  checked={formData.Activo}
                  onChange={manejarCambio}
                  className="w-4 h-4 text-primaryBlue border-gray-300 rounded focus:ring-primaryBlue"
                />
                <span className="text-sm font-medium text-gray-700">Estado Activo</span>
              </label>
            </div>
          </div>

          {error && <p className="text-red-600 text-sm mt-3">{error}</p>}

          <div className="flex items-center gap-2 mt-5">
            <button
              type="submit"
              disabled={saving}
              className="flex items-center gap-2 bg-primaryBlue text-white px-5 py-2.5 rounded-xl text-sm font-semibold shadow-sm hover:bg-blue-700 hover:shadow-md transition-all disabled:opacity-50"
            >
              {saving ? <RefreshCw size={18} className="animate-spin" /> : <Save size={18} />}
              {saving ? 'Guardando...' : editingId ? 'Actualizar' : 'Guardar'}
            </button>
            <button
              type="button"
              onClick={limpiarFormulario}
              className="flex items-center gap-2 border border-gray-300 text-gray-700 px-5 py-2.5 rounded-xl text-sm font-semibold shadow-sm hover:bg-gray-50 hover:text-gray-900 transition-all"
            >
              <Eraser size={18} />
              {editingId ? 'Cancelar' : 'Limpiar'}
            </button>
          </div>
        </form>

        {/* Filtros */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-5">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Lista de Extensiones</h3>
          <div className="flex flex-col md:flex-row gap-4 mb-4">
            <div className="flex-1 relative">
              <label className="block text-sm font-medium text-gray-700 mb-1">Filtrar por Extensión</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                  <Search size={16} />
                </div>
                <input
                  type="text"
                  value={filtroExtension}
                  onChange={(e) => setFiltroExtension(e.target.value)}
                  placeholder="Buscar extensión..."
                  className="w-full pl-9 rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primaryBlue transition-shadow"
                />
              </div>
            </div>
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">Filtrar por Estado</label>
              <select
                value={filtroEstado}
                onChange={(e) => setFiltroEstado(e.target.value)}
                className="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primaryBlue"
              >
                <option value="Todos">Todos</option>
                <option value="Activo">Activo</option>
                <option value="Inactivo">Inactivo</option>
              </select>
            </div>
          </div>

          {loading ? (
            <p className="text-sm text-gray-500 text-center py-4">Cargando datos...</p>
          ) : (
            <div className="overflow-x-auto rounded-xl border border-gray-100">
              <table className="min-w-full text-sm">
                <thead>
                  <tr className="bg-gray-100 text-gray-700 border-b border-gray-200">
                    <th className="px-4 py-3 text-left font-semibold">ID</th>
                    <th className="px-4 py-3 text-left font-semibold">Extensión</th>
                    <th className="px-4 py-3 text-left font-semibold">Usuario Asignado</th>
                    <th className="px-4 py-3 text-left font-semibold">Estado</th>
                    <th className="px-4 py-3 text-left font-semibold">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {registrosFiltrados.length === 0 ? (
                    <tr>
                      <td colSpan={4} className="px-4 py-4 text-center text-gray-500">
                        No se encontraron registros.
                      </td>
                    </tr>
                  ) : (
                    registrosFiltrados.map((item) => (
                      <tr key={item.IdExtension} className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
                        <td className="px-4 py-3">{item.IdExtension}</td>
                        <td className="px-4 py-3 font-medium text-gray-800">{item.Extension}</td>
                        <td className="px-4 py-3 text-gray-700 font-medium">{item.UsuarioAsignado || <span className="text-gray-400 italic font-normal">Sin asignar</span>}</td>
                        <td className="px-4 py-3">
                          <span className={`px-2 py-1 rounded-full text-xs font-semibold ${item.Activo ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                            {item.Activo ? 'Activo' : 'Inactivo'}
                          </span>
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex gap-2">
                            {item.Activo && (
                              <button
                                onClick={() => abrirModalAsignacion(item)}
                                title={item.IdAsignacion ? "Cambiar Usuario" : "Asignar Usuario"}
                                className={`flex items-center gap-1 px-3 py-1.5 rounded-lg transition-colors shadow-sm font-medium text-xs ${item.IdAsignacion ? 'bg-indigo-50 text-indigo-600 hover:bg-indigo-600 hover:text-white' : 'bg-green-50 text-green-600 hover:bg-green-600 hover:text-white'}`}
                              >
                                <UserPlus size={16} />
                                <span>{item.IdAsignacion ? "Cambiar" : "Asignar"}</span>
                              </button>
                            )}
                            <button
                              onClick={() => cargarParaEditar(item)}
                              title="Editar Extensión"
                              className="flex items-center gap-1 px-3 py-1.5 bg-blue-50 text-blue-600 hover:bg-blue-600 hover:text-white rounded-lg transition-colors shadow-sm font-medium text-xs"
                            >
                              <Pencil size={16} />
                              <span>Editar</span>
                            </button>
                            <button
                              onClick={() => setConfirmDeleteId(item.IdExtension)}
                              title="Eliminar Extensión"
                              className="flex items-center gap-1 px-3 py-1.5 bg-red-50 text-red-600 hover:bg-red-600 hover:text-white rounded-lg transition-colors shadow-sm font-medium text-xs"
                            >
                              <Trash2 size={16} />
                              <span>Eliminar</span>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Modal Confirmación Eliminar */}
        {confirmDeleteId && (
          <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-6">
              <h4 className="text-xl font-bold text-gray-800 mb-2">Eliminar Extensión</h4>
              <p className="text-sm text-gray-600 mb-4">¿Estás seguro de que deseas eliminar la extensión <strong>{registroAEliminar?.Extension}</strong>? Esta acción no se puede deshacer.</p>
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => setConfirmDeleteId(null)}
                  className="px-4 py-2 border border-gray-300 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                >
                  Cancelar
                </button>
                <button
                  onClick={confirmarEliminacion}
                  className="px-4 py-2 bg-red-600 text-white rounded-xl text-sm font-medium hover:bg-red-700 transition-colors"
                >
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Asignar Usuario */}
        {asignarModalOpen && (
          <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-6">
              <h4 className="text-xl font-bold text-gray-800 mb-2">Asignar Usuario</h4>
              <p className="text-sm text-gray-600 mb-4">
                Asignando usuario a la extensión <strong className="text-primaryBlue text-lg">{extensionParaAsignar?.Extension}</strong>
              </p>
              
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Seleccionar Grupo *</label>
                <select
                  value={grupoAsignado}
                  onChange={(e) => setGrupoAsignado(e.target.value)}
                  className="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primaryBlue"
                >
                  <option value="">-- Seleccione un grupo --</option>
                  {gruposList.map(grupo => (
                    <option key={grupo.idRolesWeb} value={grupo.idRolesWeb}>
                      Grupo {grupo.idRolesWeb}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-5">
                <label className="block text-sm font-medium text-gray-700 mb-1">Seleccionar Usuario *</label>
                
                <div className="relative mb-2">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-400">
                    <Search size={16} />
                  </div>
                  <input
                    type="text"
                    placeholder="Buscar usuario..."
                    value={filtroUsuario}
                    onChange={(e) => setFiltroUsuario(e.target.value)}
                    className="w-full rounded-xl border border-gray-300 pl-9 pr-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primaryBlue"
                  />
                </div>

                <div className="border border-gray-200 rounded-xl overflow-hidden h-48 overflow-y-auto">
                  <table className="w-full text-sm text-left">
                    <thead className="bg-gray-50 text-gray-600 sticky top-0 shadow-sm">
                      <tr>
                        <th className="px-3 py-2 font-medium">Nombre</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cargandoUsuarios ? (
                        <tr>
                          <td colSpan={1} className="px-3 py-4 text-center text-gray-500">Cargando usuarios...</td>
                        </tr>
                      ) : (
                        usuariosList
                          .filter(u => {
                            const nombre = u.Nombre || u.Usuario || u.Nombres || String(u.id || '');
                            return nombre.toLowerCase().includes(filtroUsuario.toLowerCase());
                          })
                          .map((u, index) => {
                            const nombreUsuario = u.Nombre || u.Usuario || u.Nombres || `Usuario ${u.id || index}`;
                            const idUnico = u.idUsuario || u.id || index;
                            
                            return (
                              <tr 
                                key={idUnico} 
                                onClick={() => {
                                  setUsuarioAsignado(nombreUsuario);
                                  setUsuarioSeleccionadoId(idUnico);
                                }}
                                className={`border-b border-gray-100 cursor-pointer transition-colors ${usuarioAsignado === nombreUsuario ? 'bg-blue-50 border-blue-200' : 'hover:bg-gray-50'}`}
                              >
                                <td className="px-3 py-2 font-medium text-gray-800">
                                  <div className="flex items-center gap-2">
                                    <input 
                                      type="radio" 
                                      name="usuarioSeleccion" 
                                      checked={usuarioAsignado === nombreUsuario}
                                      onChange={() => {
                                        setUsuarioAsignado(nombreUsuario);
                                        setUsuarioSeleccionadoId(idUnico);
                                      }}
                                      className="w-3.5 h-3.5 text-primaryBlue border-gray-300 focus:ring-primaryBlue"
                                    />
                                    {nombreUsuario}
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                      )}
                      {!cargandoUsuarios && usuariosList.filter(u => {
                        const nombre = u.Nombre || u.Usuario || u.Nombres || String(u.id || '');
                        return nombre.toLowerCase().includes(filtroUsuario.toLowerCase());
                      }).length === 0 && (
                        <tr>
                          <td colSpan={1} className="px-3 py-4 text-center text-gray-500 italic">No hay usuarios disponibles.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="flex justify-end gap-3">
                <button
                  onClick={() => setAsignarModalOpen(false)}
                  disabled={guardandoAsignacion}
                  className="px-4 py-2 border border-gray-300 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors disabled:opacity-50"
                >
                  Cancelar
                </button>
                <button
                  onClick={guardarAsignacion}
                  disabled={guardandoAsignacion}
                  className="flex items-center gap-2 px-4 py-2 bg-primaryBlue text-white rounded-xl text-sm font-medium hover:bg-blue-700 transition-colors disabled:opacity-50"
                >
                  {guardandoAsignacion ? <RefreshCw size={16} className="animate-spin" /> : <Save size={16} />}
                  Asignar
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
